import { render, staticRenderFns } from "./MessageFrame.vue?vue&type=template&id=13869909"
import script from "./MessageFrame.vue?vue&type=script&lang=js"
export * from "./MessageFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports